import theme from '../../theme/theme';

const {
  colors: { error },
} = theme;

const styles = {
  container: {
    position: 'absolute',
    top: '5vh',
    paddingLeft: '3em',
    height: '85vh',
    paddingBottom: '2em',
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  mainActions: {
    width: '70%',
  },
  mainBody: {
    width: '100%',
  },
  separation: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  bodySeparation: {
    marginBottom: '1em',
  },
  textArea: {
    width: '50em',
    display: 'block',
  },
  textAreaSingle: {
    display: 'block',
    marginTop: '0',
  },
  errorMessage: {
    color: error,
  },
  leftControl: {
    marginLeft: '1em',
  },
  disclaimer: {
    fontSize: '.9rem',
    marginBottom: '1em',
  },
};

export default styles;
